import { render } from "./EditNotificationModal.vue?vue&type=template&id=2e4d6b97&scoped=true"
import script from "./EditNotificationModal.vue?vue&type=script&lang=js"
export * from "./EditNotificationModal.vue?vue&type=script&lang=js"

import "./EditNotificationModal.vue?vue&type=style&index=0&id=2e4d6b97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4d6b97"]])

export default __exports__